import { forwardRef, ReactNode } from "react";
import classNames from "classnames";
import LoyaltyRoundButton from "components/atoms/LoyaltyRoundButton";
import useTranslate from "hooks/useTranslate";
import { LoyaltyTabs } from "constants/loyalty";
import "./styles.sass";

type LoyaltyContentProps = {
  children: ReactNode;
  isTransparent: boolean;
  activeContent: LoyaltyTabs;
  setActiveContent: (cont: LoyaltyTabs) => void;
};

const LoyaltyContent = forwardRef<HTMLDivElement, LoyaltyContentProps>(
  ({ children, activeContent, setActiveContent, isTransparent }, ref) => {
    const t = useTranslate();

    const classNameHeader = classNames(
      "LoyaltyContent__header",
      (!isTransparent ||
        activeContent === LoyaltyTabs.INFO ||
        activeContent === LoyaltyTabs.AVATAR) &&
        "LoyaltyContent__header_shadow",
    );
    const classNameBackground = classNames(
      "LoyaltyContent__hernya",
      (!isTransparent ||
        activeContent === LoyaltyTabs.INFO ||
        activeContent === LoyaltyTabs.AVATAR) &&
        "LoyaltyContent__hernya_grey",
    );
    const classNameRoot = classNames(
      "LoyaltyContent",
      activeContent === LoyaltyTabs.REWARDS && "LoyaltyContent_withMargin",
    );
    const classNameOffset = classNames(
      "LoyaltyContent__offset",
      activeContent === LoyaltyTabs.AVATAR && "LoyaltyContent__offset_avatar",
      activeContent === LoyaltyTabs.INFO && "LoyaltyContent__offset_info",
    );

    return (
      <div className={classNameRoot} ref={ref}>
        <div className={classNameBackground}>
          <div className="LoyaltyContent__hernyaSquare LoyaltyContent__hernyaSquare_left" />
          <div className={classNameHeader}>
            <div className="LoyaltyContent__square" />
            <div className="LoyaltyContent__bottomPlaceholer" />
            <LoyaltyRoundButton
              label={t("loyalty.title.bonusRewards")}
              handleClick={() => setActiveContent(LoyaltyTabs.REWARDS)}
              active={activeContent === LoyaltyTabs.REWARDS}
              className="LoyaltyContent__btn"
            />
            <LoyaltyRoundButton
              label={t("loyalty.tab.how-get")}
              handleClick={() => setActiveContent(LoyaltyTabs.INFO)}
              active={activeContent === LoyaltyTabs.INFO}
              className="LoyaltyContent__btn"
            />
            <LoyaltyRoundButton
              label={t("loyalty.tabs.avatar")}
              handleClick={() => setActiveContent(LoyaltyTabs.AVATAR)}
              active={activeContent === LoyaltyTabs.AVATAR}
              className="LoyaltyContent__btn"
            />
          </div>
          <div className="LoyaltyContent__hernyaSquare LoyaltyContent__hernyaSquare_right" />
        </div>
        <div className={classNameOffset} />
        {children}
      </div>
    );
  },
);

export default LoyaltyContent;
